import type { SVGProps } from "react";
export interface MilkBottleIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function MilkBottleIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: MilkBottleIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M8.618 9.875c1.71 0 2.825.445 3.796.83.926.365 1.707.67 2.967.67.52 0 1-.052 1.421-.127a1.125 1.125 0 0 1 .396 2.214c-.535.096-1.148.163-1.817.163-1.71 0-2.825-.445-3.795-.83-.926-.365-1.708-.67-2.968-.67a8 8 0 0 0-1.375.119l-.115.014a1.126 1.126 0 0 1-.27-2.23l.405-.062c.417-.056.871-.091 1.355-.091"
      />
      <path
        fill={color}
        d="M13.874 4.125h-3.75V5.23a5.2 5.2 0 0 1-.28 1.674l-.086.229-1.428 3.57c-.136.34-.205.702-.205 1.068V20c0 .483.391.874.875.875h6a.875.875 0 0 0 .876-.875v-8.23c0-.274-.04-.546-.118-.808l-.09-.26-1.426-3.57a5.1 5.1 0 0 1-.368-1.902zm2.25 1.105c0 .366.071.728.207 1.068l1.427 3.57.086.228c.186.538.281 1.104.281 1.675V20c0 1.726-1.4 3.125-3.126 3.125H9A3.125 3.125 0 0 1 5.876 20v-8.23c0-.651.124-1.297.366-1.902l1.428-3.57.09-.26q.115-.395.116-.808V4.117a1.124 1.124 0 0 1-1-1.117V2l.006-.116A1.125 1.125 0 0 1 8.001.875H16c.621 0 1.125.504 1.125 1.125v1c0 .58-.438 1.056-1 1.118V5.23Z"
      />
    </svg>
  );
}
